module.exports = __webpack_public_path__ + "static/media/laptop_online_dance_fitness_classes.9d44eefa.webp";